import * as React from "react"
import Layout from './layout';

export default ({title,children}) => {
  return (
      <Layout title={title}>
          <div className="container body-content">
            <div className="row">
                <div className="col-lg-12">
                    <h1 className="page-header">{title}</h1>
                </div>
            </div>

            {children}
          </div>
      </Layout>
  );
}

